"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var ActionText = function (_a) {
    var children = _a.children, className = _a.className, disabled = _a.disabled, onClick = _a.onClick, onMouseDown = _a.onMouseDown, _b = _a.testid, testid = _b === void 0 ? 'actionText' : _b, underline = _a.underline, rest = __rest(_a, ["children", "className", "disabled", "onClick", "onMouseDown", "testid", "underline"]);
    return (react_1.default.createElement(StyledButton, __assign({}, rest, { "$underline": underline, className: className, "data-testid": testid, disabled: disabled, onClick: onClick, onMouseDown: onMouseDown }), children));
};
exports.default = ActionText;
var StyledButton = styled_components_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: none;\n    border: none;\n    color: ", ";\n    cursor: pointer;\n    font: inherit;\n    padding: 0;\n\n    &:disabled {\n        cursor: not-allowed;\n        color: ", ";\n        &:hover {\n            color: ", ";\n        }\n    }\n\n    &:focus {\n        outline: 0;\n    }\n\n    &:hover {\n        color: ", ";\n        text-decoration: none;\n    }\n\n    text-decoration: ", ";\n"], ["\n    background: none;\n    border: none;\n    color: ", ";\n    cursor: pointer;\n    font: inherit;\n    padding: 0;\n\n    &:disabled {\n        cursor: not-allowed;\n        color: ", ";\n        &:hover {\n            color: ", ";\n        }\n    }\n\n    &:focus {\n        outline: 0;\n    }\n\n    &:hover {\n        color: ", ";\n        text-decoration: none;\n    }\n\n    text-decoration: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.blue100;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.blue300;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.blue300;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.blue200;
}, function (_a) {
    var $underline = _a.$underline;
    return ($underline ? 'underline' : 'none');
});
var templateObject_1;
